import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import {
  REFRESH_STATUS_DEFAULT,
  REFRESH_STATUS_DISABLED,
  consecusiveReqDelay,
} from '@/const'
import { User2FAState } from '@/const'
import { useUserAPIStore } from '@/stores'
import { User } from '@/types'

export const useUserStore = defineStore('user', () => {
  type FilterbyType = {
    type: 'nft' | 'asset' | 'app'
    status: 'disabled' | 'loading' | 'refresh'
  }
  const refreshStatus = ref<FilterbyType[]>([])

  const userAPIStore = useUserAPIStore()

  const userInfo = computed(() => {
    if (!userAPIStore.userInfo) return
    return new User(userAPIStore.userInfo)
  })

  const getRefreshStatus = (type: FilterbyType['type']) => {
    const result = refreshStatus.value.find(
      (res: FilterbyType) => res.type === type,
    )

    if (result?.status !== undefined) {
      return result.status
    }
    return REFRESH_STATUS_DEFAULT
  }

  const setRefresh = ({ type, status }: FilterbyType) => {
    const result = refreshStatus.value.find(
      (res: FilterbyType) => res.type === type,
    )
    if (result && status === REFRESH_STATUS_DISABLED) {
      setTimeout(() => {
        result.status = REFRESH_STATUS_DEFAULT
      }, consecusiveReqDelay)
    }
    if (result) {
      return (result.status = status)
    }
    refreshStatus.value.push({
      type: type,
      status,
    })
  }
  const isSet2FA = computed(() => {
    if (userInfo.value) {
      return userInfo.value!.use2FA >= User2FAState.AUTHENTICATED
    } else {
      return 0
    }
  })

  return {
    userInfo,
    getRefreshStatus,
    setRefresh,
    isSet2FA,
  }
})
